/**
 * Step1 で受け付けるヘッダーの並び。 日本語 (`ja`) は列名・順序とも完全一致
 * (大文字小文字を区別する厳格モード、 backend と同じ判定)、 英語 (`en`) は大文字小文字を
 * 区別しない (`conventions.md`「CSV の英語表示」「アップロードは、表示言語に関わらず
 * ヘッダー行・区分値とも日本語・英語のどちらでも受理する」)。 どれか 1 つと一致すれば受理する。
 */
export type AcceptedCsvHeaders = {
  ja: ReadonlyArray<readonly string[]>
  en: ReadonlyArray<readonly string[]>
}

/**
 * 実際のヘッダーが受理するヘッダーのどれかと一致するか。 日本語は列名・順序とも
 * 完全一致、 英語は大文字小文字を区別しない (`AcceptedCsvHeaders`)。 セルの trim は
 * 呼び出し側が行う。
 */
export function isAcceptedCsvHeader(
  actual: readonly string[],
  { ja, en }: AcceptedCsvHeaders,
): boolean {
  return (
    ja.some(
      (expected) =>
        actual.length === expected.length &&
        actual.every((col, i) => col === expected[i]),
    ) ||
    en.some(
      (expected) =>
        actual.length === expected.length &&
        actual.every(
          (col, i) => col.toLowerCase() === expected[i].toLowerCase(),
        ),
    )
  )
}
